// V1.5+ Slice 6 — Disrupt Uplink tuning per docs/02_GAME_DESIGN.md §13.8 / §15 / §16.
//
// Disrupt Uplink is the Assault's E (secondary) ability. It is the THIRD leg
// of the V1.5+ disruption arc, completing the mechanical-signature triangle
// established by Slice 2 (Cut Link) and Slice 5 (Jam Relay):
//
//   Cut Link    (Recon E)    — HAMMER : binary chain destruction. The cut
//                              relay stops conducting; downstream relays
//                              cascade isolated; forward `mini_turret`s
//                              anchored on those relays go offline.
//   Jam Relay   (Engineer E) — SCALPEL: binary vision suppression. The
//                              jammed relay's vision pulse is suppressed,
//                              but the chain stays intact (BFS still
//                              traverses through; downstream relays remain
//                              connected; forward turrets stay online).
//   Disrupt     (Assault E)  — DIAL   : analog turret degradation. While
//   Uplink                     the targeted relay is in a disruption
//                              window, forward turrets anchored on it
//                              keep firing but at reduced fire rate
//                              (`DISRUPT_UPLINK_FIRE_RATE_MULT`) and
//                              reduced range (`DISRUPT_UPLINK_RANGE_MULT`)
//                              for the window. The chain stays intact;
//                              `isOnline` is unaffected. The mechanical
//                              novelty per docs/11_ROADMAP.md Phase 6+ row
//                              is "direct turret degradation rather than
//                              binary on/off" — a continuous reduction of
//                              forward firepower instead of an on/off
//                              switch.
//
// Calibration:
//   - Channel `DISRUPT_UPLINK_CHANNEL_SEC` 2.5 s — between Recon's 3 (mobile
//     and fragile, can break range fast) and Engineer's 2 (sturdier; lower
//     mobility means a longer channel is a death sentence). Assault is
//     medium-mobility / medium-tankiness, so mid.
//   - Range `DISRUPT_UPLINK_TARGET_RANGE_PX` 240 px — Assault commits closer
//     than Recon (220) but not as close as Engineer (200). Assault wants to
//     be in trade range anyway, so the closer commit is on-shape.
//   - Duration `DISRUPT_UPLINK_DURATION_SEC` 25 s — between Cut Link's 30
//     and Jam's 20. Analog effects feel less "decisive" than binary ones,
//     so a slightly longer window is fine.
//   - Cooldown `DISRUPT_UPLINK_COOLDOWN_SEC` 40 s — between 45 and 35.
//   - `DISRUPT_UPLINK_FIRE_RATE_MULT` 0.6 — turret fires at 60% of normal
//     rate (40% reduction). Calibrated against forward-turret time-to-kill
//     on a Recon: base TTK is ~3 s; 60% rate makes it ~5 s, which is enough
//     for an attacking squad to push past where a non-disrupted turret
//     would have killed them.
//   - `DISRUPT_UPLINK_RANGE_MULT` 0.7 — turret's effective range is 70% of
//     `BUILDINGS.mini_turret.range`. Roughly matches the "you can stand on
//     the relay rim and not eat damage" feeling — the strategic read for
//     the attacker.
//
// Per Rule 17 (anti-turtling) and Rule 18 (felt on the battlefield), the
// values are tuned so the strategic dynamic §15 calls out emerges:
//   "I disrupted his mid relay. His forward turrets there are firing
//    slower and shorter; my Assault push survives the trade that would
//    have died without the disrupt."
//
// Don't tune these without a corresponding playtest verification: at
// minimum a 30-match `playtest-direct.mjs 30` showing the §17
// `averageRelayFlipsPerMatch` gate still ≥ baseline (6.37 as of pre-merge).
export const DISRUPT_UPLINK_TARGET_RANGE_PX = 240;
export const DISRUPT_UPLINK_TARGET_RANGE_SQ =
  DISRUPT_UPLINK_TARGET_RANGE_PX * DISRUPT_UPLINK_TARGET_RANGE_PX;
export const DISRUPT_UPLINK_CHANNEL_SEC = 2.5;
export const DISRUPT_UPLINK_DURATION_SEC = 25;
export const DISRUPT_UPLINK_COOLDOWN_SEC = 40;
export const DISRUPT_UPLINK_FIRE_RATE_MULT = 0.6;
export const DISRUPT_UPLINK_RANGE_MULT = 0.7;
